import { render, staticRenderFns } from "./AuthorityList.vue?vue&type=template&id=39152762&"
import script from "./AuthorityList.vue?vue&type=script&lang=ts&"
export * from "./AuthorityList.vue?vue&type=script&lang=ts&"
import style0 from "./AuthorityList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports